import { root, id } from './status';

export const status = {
  ...root,
  id,
};
